import { z } from "zod";
import { iconNameZodString } from "../icon-name";
import { idZodSchema } from "../id";
import { colorSetNameZodEnum } from "../stylable/color-theme/color-theme";
import { requiredTranslatableZodSchema } from "../translations/translation";

const agendaStatZodObject = z.object({
    _id: idZodSchema,
    label: requiredTranslatableZodSchema,
    value: z.number(),
    valueType: z.enum(["number", "percentage"]),
    statGroup: z.enum([
        // TODO: Decide on which stat groups
        "resource_types",
        "quantity_types",
        "orders",
        "reservations",
        "extras",
        "products",
    ]),
    iconName: iconNameZodString,
    colorSet: colorSetNameZodEnum,
});

type Agenda_Stat = z.infer<typeof agendaStatZodObject>;

const agenda_StatFactory = (params: Agenda_Stat): Agenda_Stat => {
    return agendaStatZodObject.parse(params);
};

export { agenda_StatFactory, agendaStatZodObject };
export type { Agenda_Stat };
